import React, { useState } from 'react'
import clsx from 'clsx'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'

import useStyles from './EmailBoxComponent.styles'
import { EmailBoxComponentProps } from './EmailBoxComponentProps'

const EmailBoxComponent: React.FC<EmailBoxComponentProps> = ({
  title,
  description,
  billingPeriod,
  originalPrice,
  offerPrice,
  voucher
}) => {
  const classes = useStyles()
  const [email, setEmail] = useState('')
  const [emailError, setEmailError] = useState('')
  let priceBeforeDot = ''
  let priceAfterDot = ''
  if (offerPrice !== null && offerPrice !== undefined) {
    [priceBeforeDot, priceAfterDot] = offerPrice.toString().split('.')
  }

  const handleChange = (e: any) => {
    setEmail(e.target.value)
  }

  const handleSubmit = () => {
    setEmailError('')
    const isTestEnv = window.location.href.includes('test')
    const REGES_EMAIL = new RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i)
    const cleanEmail = email?.trim() || ''
    const cleanVoucher = voucher?.trim() || ''

    // Only validate if email is NOT empty
    if (cleanEmail && !REGES_EMAIL.test(cleanEmail)) {
      // Invalid email address
      setEmailError('Invalid email address')
    } else {
      // Encode the email and voucher to ensures cookie-safe values
      // Set cookie for the parent domain (.neontv.co.nz)
      // Note: 'Secure' and 'SameSite=Lax' required if using HTTPS and cross-site
      // Short-lived cookie - only 10 seconds
      if (cleanEmail) {
        document.cookie = `email=${encodeURIComponent(cleanEmail)}; domain=.neontv.co.nz; path=/; secure; samesite=Lax; max-age=10`
      }

      if (cleanVoucher) {
        document.cookie = `voucher=${encodeURIComponent(cleanVoucher)}; domain=.neontv.co.nz; path=/; secure; samesite=Lax; max-age=10`
      }

      // Navigate to sign up page even if the email field is empty
      if (isTestEnv) {
        window.location.href = 'https://www.test2.npe.neontv.co.nz/signup/account'
      } else {
        window.location.href = 'https://www.neontv.co.nz/signup/account'
      }
    }
  }

  const unit = billingPeriod === 'month' ? 'mth' : billingPeriod

  return (
    <div className={classes.emailBoxContainer}>
      <div className={classes.title}>{title}</div>

      <div className={classes.description}>
        {documentToReactComponents(description)}
      </div>

      {originalPrice && offerPrice && billingPeriod && (
        <>
          <div className={classes.originalPrice}>
            &nbsp;$
            {originalPrice}
            /{billingPeriod}
            &nbsp;
          </div>
    
          <div className={classes.priceAmount}>
            <span className={classes.currency}>$</span>
            <span className={classes.priceAmountBeforeDot}>{priceBeforeDot}</span>
            <div className={classes.priceAmountRightFrame}>
              <span className={classes.priceAmountAfterDot}>{priceAfterDot}</span>
              <span className={classes.priceAmountUnit}>/{unit}</span>
            </div>
          </div>
        </>
      )}

      {voucher && (
        <div className={classes.text}>
          Enter voucher code at checkout: <span className={classes.voucher}>{voucher}</span>
        </div>
      )}

      <div className={classes.content}>
        <div className={classes.inputFrame}>
          <input
            type="email"
            name="email"
            value={email}
            onChange={handleChange}
            className={clsx(classes.input, emailError && classes.errorBorder)}
            placeholder='Enter your email address'
          />

          {
            emailError && (
              <span className={classes.error}>
                {emailError}
              </span>
            )
          }
        </div>


        <button
          onClick={handleSubmit}
          className={classes.button}
          type="button"
        >
          GET STARTED
        </button>
      </div>
    </div>
  )
}

export default EmailBoxComponent
